(() => {
  const initialised = new WeakSet();
  const initialise = (root = document) => {
    const headers = [...root.querySelectorAll('[data-site-header]')];
    if (root.matches?.('[data-site-header]')) headers.unshift(root);
    headers.forEach(header => {
      if (initialised.has(header)) return;
      initialised.add(header);
      const toggle = header.querySelector('[data-nav-toggle]');
      const search = header.querySelector('.header-search-menu');
      const searchToggle = search?.querySelector('summary');
      const searchInput = search?.querySelector('input[type="search"]');
      const menus = [...header.querySelectorAll('.mega-menu')];
      const closeMenus = () => menus.forEach(menu => { menu.open = false; });
      const closeNavigation = () => {
        closeMenus();
        header.dataset.navOpen = 'false';
        toggle?.setAttribute('aria-expanded', 'false');
      };
      const closeSearch = () => {
        if (search) search.open = false;
        searchToggle?.setAttribute('aria-expanded', 'false');
      };
      const close = () => { closeNavigation(); closeSearch(); };
      header.dataset.navEnhanced = 'true';
      close();
      toggle?.addEventListener('click', () => {
        const open = header.dataset.navOpen !== 'true';
        closeSearch();
        closeMenus();
        header.dataset.navOpen = String(open);
        toggle.setAttribute('aria-expanded', String(open));
      });
      search?.addEventListener('toggle', () => {
        searchToggle?.setAttribute('aria-expanded', String(search.open));
        if (search.open) {
          closeNavigation();
          searchInput?.focus({ preventScroll: true });
        }
      });
      menus.forEach(menu => menu.addEventListener('toggle', () => {
        if (!menu.open) return;
        closeSearch();
        menus.forEach(other => { if (other !== menu) other.open = false; });
      }));
      document.addEventListener('pointerdown', event => {
        if (header.isConnected && !header.contains(event.target)) close();
      });
      header.addEventListener('click', event => {
        if (event.target.closest('.site-navigation a')) closeNavigation();
      });
      header.addEventListener('focusout', event => {
        if (event.relatedTarget && !header.contains(event.relatedTarget)) close();
      });
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        if (search?.open) {
          closeSearch();
          searchToggle?.focus();
          return;
        }
        const opened = menus.find(menu => menu.open);
        if (opened) {
          opened.open = false;
          opened.querySelector('summary')?.focus();
        } else if (header.dataset.navOpen === 'true') {
          closeNavigation();
          toggle?.focus();
        }
      });
      const breakpoint = matchMedia('(max-width: 800px)');
      breakpoint.addEventListener('change', close);
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  const zoomAllowed = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  document.addEventListener('pointermove', event => {
    const item = event.target.closest('[data-product-zoom]');
    if (!item || event.pointerType !== 'mouse' || !zoomAllowed.matches) return;
    const rect = item.getBoundingClientRect();
    item.style.setProperty('--zoom-x', `${Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100))}%`);
    item.style.setProperty('--zoom-y', `${Math.max(0, Math.min(100, (event.clientY - rect.top) / rect.height * 100))}%`);
  });
  document.addEventListener('pointerout', event => {
    const item = event.target.closest('[data-product-zoom]');
    if (!item || item.contains(event.relatedTarget)) return;
    item.style.removeProperty('--zoom-x');
    item.style.removeProperty('--zoom-y');
  });
})();
